import lessRequire from '../../config/less-require-resolver';
import { actions, selectors } from './';
import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import renderViewsState from '../shared/render-views-state';
import { bindActionCreators } from 'redux';

import SwitchOffers from '../../modules/shared/switch';
import Filters from '../../modules/shared/filters/main';
import Calendar from '../../modules/shared/calendar/main';

import map from 'lodash/map';

lessRequire('modules/global-postback/log.less');

const Log = renderViewsState(props => {
	const { intl } = props;
	const switchControlConfig = [{
		className: '',
		title: intl('Настройки'),
		url: 'campaigns/global-postback/'
	}, {
		className: '',
		title: intl('Глобальный постбэк лог'),
		url: 'campaigns/global-postback/log/'
	}, {
		className: '',
		title: intl('Переотправка постбека'),
		url: 'campaigns/global-postback/resend/'
	}];

	return (
		<div className="global-postback container">
			<div className="content-container">
				<div className="content-container__title">
					<h2 className="font-proxima-nova-bold">{intl('Глобальный постбэк')}</h2>
					<div className="global-postback__switch">
						<SwitchOffers links={switchControlConfig}  intl={intl}/>
					</div>
				</div>
				<div className="global-postback-content">
					<div className="postback__table-tools">
						<Filters {...props}/>
						<div className="tools--buttons">
							<Calendar
								{...props.calendar}
								onInit={props.calendarPostbackListInit}
								onToggle={props.calendarPostbackListToggle}
								onChange={e => {
									props.calendarPostbackListChange(e);
								}}
								onApply={props.calendarPostbackListApply}
							/>
							<div className="postback-buttons__container">
								<button className="submit-btn" onClick={props.fetchPostbacks}></button>
								<button className="save-btn" onClick={props.downloadPostbacks}></button>
							</div>
						</div>
					</div>
					<table className="dashboard-table">
						<thead className="dashboard-table__head font-proxima-nova-semibold">
							<tr>
								<th>{intl('Время')}</th>
								<th>{intl('Поток')}</th>
								<th>Url</th>
								<th>{intl('Код ответа')}</th>
								<th className="error-col">{intl('Ошибка')}</th>
							</tr>
						</thead>
						<tbody className="dashboard-table__body">
							{ props.dataTable && props.dataTable.tableRows
							&& map(props.dataTable.tableRows, (row, i) => {
								return (
									<tr key={i}>
										<td className="datetime">
											<p>{moment(row.date).format('DD.MM.YYYY')}</p>
											<p>{moment(row.date).format('HH:mm:ss')}</p>
										</td>
										<td className="title">
											<span>{`${row.campaign} (${intl('оффер')} ${row.offer})`}</span>
										</td>
										<td className="url"><span>{decodeURIComponent(row.url)}</span></td>
										<td className="code"><span>{row.status != 0 ? row.status : intl('Сервер не найден')}</span></td>
										<td className="error-col"><span>{row.error_stack}</span></td>
									</tr>
								);
							})
							}
							{props.dataTable && props.dataTable.showMoreLogsButton
							&& showMoreRows(props.showMore, intl)}
						</tbody>
					</table>
				</div>
			</div>
		</div>
	);
});

const showMoreRows = (onShowMore, intl) => (
	<tr className="show-more">
		<th colSpan="16">
			<a href="#" className="icon-show-more font-proxima-nova-regular" onClick={ e => {
				e.preventDefault(); onShowMore();
			}}>
				<span>
					{intl('Показать ещё')}
				</span>
			</a>
		</th>
	</tr>
);

export default connect(
	state => ({
		data: selectors.getData(state),
		progressBar: selectors.getProgressBar(state),
		dataTable: selectors.getLogTable(state),
		errors: selectors.getError(state),
		calendar: selectors.getPostbackListCalendar(state),
		filters: selectors.getFilters(state),
		appliedFilters: selectors.getAppliedFilters(state),
		intl: selectors.getIntl(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Log);



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/global-postback/log.js